const { httpGet } = require("../utils");
const { url } = require("../config");

const UploaderControl = function(params, target) {
  var _this = {},
    _event = null,
    _params = params,
    _delegate = params.delegate;
  _target = params.target || "aws";

  function _onStart(file) {
    function onUpload(evt) {
      if (_delegate.onUpload) _delegate.onUpload(file);
    }

    function onProgress(evt) {
      if (evt.lengthComputable) {
        if (_delegate.onProgress)
          _delegate.onProgress(file, Math.round((evt.loaded / evt.total) * 100));
      }
    }

    function onError(e) {
      if (_delegate.onError) _delegate.onError(file, e.message);
    }

    function onCompleted(evt) {
      if (_delegate.onCompleted) _delegate.onCompleted(file);
    }

    var xhrObj = new XMLHttpRequest();
    xhrObj.upload.addEventListener("loadstart", onUpload, false);
    xhrObj.upload.addEventListener("progress", onProgress, false);
    xhrObj.upload.addEventListener("load", onCompleted, false);
    xhrObj.upload.addEventListener("error", onError, false);
    xhrObj.open("PUT", file.signedRequest, true);

    if (_target === "aws") {
      //xhrObj.setRequestHeader("x-amz-acl", "public-read"); //AR: this caused AWS signature to mismatch
      xhrObj.setRequestHeader("Content-Type", file.type);
    }

    xhrObj.send(file);
  }

  _this.queue = function(event) {
    _event = event;
  };

  _this.processQueue = function(path, target = "aws", pathPrefix) {
    var file = _event.files[0];

    var fparams = {
      fileName: file.name,
      fileType: file.type,
      target: _target,
    };

    if (path) {
      fparams.filePath = path;
    }

    //Added non lambda images process support
    if (pathPrefix) {
      fparams.pathPrefix = pathPrefix;
    }

    httpGet(url + "/api/uploader", fparams, function (data) {
      try {
        file.signedRequest = data.signedRequest;
        file.finalURL = data.downloadURL;
        file.uploadURL = data.uploadURL;

        if (!data.signedRequest) {
          return _delegate.onError(file, "Failed to receive an upload url");
        }

        _onStart(file);
      } catch (ex) {
        console.log(ex);
        return _delegate.onError(file, "Error uploading");
      }
    });
  };

  return _this;
};

module.exports = UploaderControl;
